import config from '@/config/config.ts';

export function isDevEnvironment() {
  return import.meta.env.DEV || config.VITE_APP_TENANT_NAME === 'development';
}
